import api from './api';

// Campagnes de satisfaction par SMS (import manuel de fichiers).
const satisfactionApi = {
  // Dépose 1..n fichiers + type d'offre → tableau de contrôle (aucun envoi).
  analyser: (fichiers, type) => {
    const fd = new FormData();
    fichiers.forEach((f) => fd.append('fichiers', f));
    if (type) fd.append('type', type);
    return api.post('/satisfaction-campagne/analyser', fd);
  },
  // Envoi réel (confirmation explicite côté serveur).
  envoyer: (contacts, template) =>
    api.post('/satisfaction-campagne/envoyer', { contacts, template, confirmer: true }),
};

export default satisfactionApi;
